<div class="container">
    <div class="row mt-5">
        <div class="d-flex justify-content-around">
            <h1 class="text-center ms-auto">Payment Successful</h1>
            <span class="me-1 ms-1"></span>
            <mat-icon class="text-success h-100 me-auto" style="font-size: xx-large; width: auto;">check_circle</mat-icon>
        </div>
        <p class="text-center" *ngIf="paymentPlan">Welcome aboard! Your Pulsy AI <span class="fw-bold">{{paymentPlan.toLowerCase()}}</span> subscription is now active. We're excited to have you with us!</p>
        <p class="text-center" *ngIf="!paymentPlan">Welcome aboard! Your subscription is now active. We're excited to have you with us!</p>
        <button mat-raised-button class="w-25 mx-auto mt-5" (click)="onSeeAgentsClicked()">See ai agents</button>
    </div>

</div>